import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import { Button, ButtonType } from '../Button';
import { Modal } from '../Modal';

// Angular source: apps/angular/src/js/ng/booking/components/interest-warning-modal/
// Warns the parent before a booking request that there may be a mismatch
// (e.g. caregiver already expressed interest elsewhere).
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  caregiverName?: string;
}

export const InterestWarningModal = ({
  isOpen,
  onClose,
  onContinue,
  caregiverName,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const name = caregiverName ?? t('components.modals.interestWarning.defaultCaregiver');
  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-full max-w-md'>
      <Button
        aria-label={t('common.close')}
        onClick={onClose}
        className='absolute right-2 top-2 text-gray-400 hover:text-gray-500 transition-colors'
      >
        <FontAwesomeIcon icon={faXmark} className='w-5 h-5' />
      </Button>
      <h3 className='font-semibold mb-2'>
        {t('components.modals.interestWarning.title', { caregiverName: name })}
      </h3>
      <p className='mb-4'>{t('components.modals.interestWarning.body')}</p>
      <div className='text-right'>
        <Button buttonType={ButtonType.secondary} className='mr-2' onClick={onClose}>
          {t('components.modals.interestWarning.goBack')}
        </Button>
        <Button buttonType={ButtonType.primary} onClick={onContinue}>
          {t('components.modals.interestWarning.sendAnyway')}
        </Button>
      </div>
    </Modal>
  );
};
